var map = {
	"./1-1.jpg": "eeda",
	"./1.jpg": "fb3e",
	"./1.png": "a3ac",
	"./2.png": "85fb",
	"./3-1.png": "0fd9",
	"./3.jpg": "df36",
	"./3.png": "41d6",
	"./4.png": "e25d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b591";